import { css } from '@emotion/react';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import GetHelpTextButton from 'src/components/creditApplication/GetHelpTextButton';

const ApplicationUnavailablePage = () => {
  return (
    <CreditApplicationPageLayout
      showLogo={false}
      icon='AlertFilled24'
      title='Gold Card applications are closed for today'
      subtitle='We are no longer accepting applications for the Gold Card today. Please try again tomorrow.'
    >
      <div css={root}>
        <GetHelpTextButton />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;

export default ApplicationUnavailablePage;
